import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, reactive } from "vue";
import i18n from "@/core/plugins/i18n";
import type { FormInstance, FormRules } from "element-plus";
import SimpleForm from "@/components/SimpleForm.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangePasswordForm',
  setup(__props, { expose: __expose }) {

const ruleFormRef = ref<FormInstance>();
const t = i18n.global.t;
const formData = ref({
  pass: "",
  checkPass: "",
});

const isLoading = ref(true);
const modalRef = ref<InstanceType<typeof SimpleForm>>();
const tradeAccount = ref<any>();

const validatePass = (rule: any, value: any, callback: any) => {
  if (value === "") {
    callback(new Error(t("error.signup_ps_require")));
  } else {
    if (formData.value.checkPass !== "") {
      if (!ruleFormRef.value) return;
      ruleFormRef.value.validateField("checkPass", () => null);
    }
    callback();
  }
};
const validatePass2 = (rule: any, value: any, callback: any) => {
  if (value === "") {
    callback(new Error(t("error.signup_ps_require")));
  } else if (value !== formData.value.pass) {
    callback(new Error(t("error.signup_ps_match")));
  } else {
    callback();
  }
};

const rules = reactive<FormRules>({
  pass: [{ required: true, validator: validatePass, trigger: "blur" }],
  checkPass: [{ required: true, validator: validatePass2, trigger: "blur" }],
});

const show = (_tradeAccount: any) => {
  isLoading.value = true;
  resetForm();
  modalRef.value?.show();
  tradeAccount.value = _tradeAccount;
  isLoading.value = false;
};

const hide = () => {
  resetForm();
  modalRef.value?.hide();
};

const resetForm = () => {
  if (!ruleFormRef.value) return;
  ruleFormRef.value.resetFields();
};

const submitForm = () => {
  if (!ruleFormRef.value) return;
  ruleFormRef.value.validate((valid) => {
    if (valid) {
      console.log("submit!");
    } else {
      console.log("error submit!");
      return false;
    }
  });
};

__expose({
  show,
  hide,
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(SimpleForm, {
    ref_key: "modalRef",
    ref: modalRef,
    title: _ctx.$t('action.resetMT4Password'),
    "is-loading": isLoading.value,
    submit: submitForm,
    "disable-submit": ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form, {
        ref_key: "ruleFormRef",
        ref: ruleFormRef,
        model: formData.value,
        "status-icon": "",
        rules: rules,
        "label-width": "120px",
        class: "demo-ruleForm"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.password'),
            prop: "pass"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.pass,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.pass) = $event)),
                autocomplete: "off",
                required: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_form_item, {
            label: _ctx.$t('fields.confirmPassword'),
            prop: "checkPass"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: formData.value.checkPass,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.checkPass) = $event)),
                autocomplete: "off",
                required: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _: 1
  }, 8, ["title", "is-loading"]))
}
}

})